import {Component, HostListener, OnInit} from '@angular/core';
import {DocumentsService} from '../../../services/documents.service';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'move-modal',
    templateUrl: './move-modal.component.html',
    styleUrls: ['./move-modal.component.scss']
})
export class MoveModalComponent implements OnInit {

    public data: any = null;
    public foldersList: Array<any> = [];
    public isShowPreloader: boolean = false;
    public modalType: string = '';
    public currentPath: Array<any> = [{name: 'Home', id: 1}];

    constructor(public api: ApiClientService,
                public ds: DocumentsService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        this.data = this.ds.currentItem;
        this.currentPath = this.currentPath.concat(JSON.parse(JSON.stringify(this.ds.path)));
        this.modalType = this.ds.currentItem.type == 'directory' ? 'Folder' : 'File';
        this.getFoldersList(this.data.parent);
        this.urlService.modalOpened.emit();
    }

    onSubmit(form: NgForm) {
        const currentDirectory = this.currentPath[this.currentPath.length - 1].id;
        const data = {parent: currentDirectory};

        const url = `/api/v1/documents/${this.ds.currentItem.id}`;

        this.api.patch('domainDocuments', url, data).subscribe(() => {
            toastr.success('Permissions was updated!');
            this.hideModal();
            this.ds.goTo();
        }, error => this.api.errorHandler(error, `Failed to move ${this.modalType}!`));
    }

    navigateToDirectory(item, index) {
        this.getFoldersList(this.currentPath[index].id);
        this.currentPath = this.currentPath.slice(0, index + 1);
    }

    goToDirectory(path) {
        this.currentPath.push(path);
        this.getFoldersList(this.currentPath[this.currentPath.length - 1].id);
    }

    goToParentFolder() {
        this.getFoldersList(this.currentPath[this.currentPath.length - 2].id);
        this.currentPath.splice(this.currentPath.length - 1, 1);
    }

    hideModal() {
        this.ds.isMoveModalShow = false;
        this.urlService.modalClosed.emit();
    }

    getFoldersList(parent) {
        this.foldersList = [];
        this.isShowPreloader = true;
        const queryParams = '&per-page=10000&order-by=name|asc';
        this.ds.fetchDocuments(queryParams, parent).subscribe((res) => {
            res.entities = res.entities.map(e => ({...e, isPublic: e.public}));
            this.foldersList = res.entities.filter(doc => doc.type == 'directory' && doc.id != this.ds.currentItem.id);
            this.isShowPreloader = false;
        });
    }

    isPathNotEqualOriginal(): boolean {
        return this.ds.currentItem.parent == this.currentPath[this.currentPath.length - 1].id;
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.ds.hideUploadFileModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/documents/move-modal/move-modal.component.ts